export default __webpack_public_path__ + "static/media/admin3.42c9b08b.png";